function createStore(initialState) {
  var state = Object.assign({}, initialState);
  var listeners = [];
  var onces = [];
  return {
    get state() {
      return state;
    },

    hydrate: function hydrate(fn) {
      state = Object.assign({}, state, typeof fn === 'function' ? fn(state) : fn);
      return function (done) {
        for (var i = 0, list = listeners; i < list.length; i += 1) {
          var fn = list[i];
          fn(state);
        }

        while (onces.length) {
          onces.pop()(state);
        }

        done && done();
      };
    },
    listen: function listen(fn) {
      listeners.indexOf(fn) < 0 && listeners.push(fn);
      return function () {
        return listeners.splice(listeners.indexOf(fn), 1);
      };
    },
    once: function once(fn) {
      onces.indexOf(fn) < 0 && onces.push(fn);
    },
    reset: function reset() {
      state = initialState;
    },
    replace: function replace(s) {
      state = s;
    }
  };
}

export default createStore;